var moduleMap = {
	"./apiClient": () => {
		return Promise.all(/* __federation_expose_apiClient */[__webpack_require__.e(869), __webpack_require__.e(5)]).then(() => (() => ((__webpack_require__(39702)))));
	},
	"./AuthContext": () => {
		return Promise.all(/* __federation_expose_AuthContext */[__webpack_require__.e(96), __webpack_require__.e(869), __webpack_require__.e(517), __webpack_require__.e(557), __webpack_require__.e(259)]).then(() => (() => ((__webpack_require__(29053)))));
	},
	"./components/InteractionTimeline": () => {
		return Promise.all(/* __federation_expose_components__InteractionTimeline */[__webpack_require__.e(96), __webpack_require__.e(869), __webpack_require__.e(517), __webpack_require__.e(275)]).then(() => (() => ((__webpack_require__(11882)))));
	},
	"./CompanyContext": () => {
		return Promise.all(/* __federation_expose_CompanyContext */[__webpack_require__.e(96), __webpack_require__.e(869), __webpack_require__.e(517), __webpack_require__.e(557), __webpack_require__.e(850)]).then(() => (() => ((__webpack_require__(56306)))));
	},
	"./moduleRegistry": () => {
		return __webpack_require__.e(/* __federation_expose_moduleRegistry */ 925).then(() => (() => ((__webpack_require__(83154)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});